import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HolidaysComponent} from './holidays/holidays.component';
import {OfficesComponent} from './offices/offices.component';
import {SettingsComponent} from './settings.component';
import {TechStacksAndPositionsComponent} from './tech-stacks-and-positions/tech-stacks-and-positions.component';
import {PermissionsGuard} from 'src/app/guards/permissions.guard';
import {UserRoles, roles} from 'src/app/shared/utils/roles';

const routes: Routes = [
  {
    path: '',
    component: SettingsComponent,
    children: [
      {
        path: 'holidays',
        component: HolidaysComponent,
      },
      {
        path: 'offices',
        component: OfficesComponent,
        canActivate: [PermissionsGuard],
        data: {
          permission: [
            ...roles.CEO,
            ...roles.HR_DEPARTMENT,
            ...roles.ACCOUNTANT_DEPARTMENT,
          ],
        },
      },
      {
        path: 'tech-stacks-and-positions',
        component: TechStacksAndPositionsComponent,
        canActivate: [PermissionsGuard],
        data: {
          permission: [
            ...roles.CEO,
            ...roles.HR_DEPARTMENT,
            ...roles.DELIVERY_DEPARTMENT,
            UserRoles.headOfRecruitment,
            UserRoles.leadOfRecruitment,
          ],
        },
      },
      {
        path: '',
        redirectTo: 'holidays',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SettingsRoutingModule {}
